import React from 'react';
import ColorPicker from '../ui/ColorPicker';

const TracklistBlockEditor = ({ block, onUpdate }) => {
  const handleChange = (field, value) => {
    onUpdate(block.id, {
      config: {
        ...block.config,
        [field]: value,
      },
    });
  };

  const handleStyleChange = (field, value) => {
    onUpdate(block.id, {
      styles: {
        ...block.styles,
        [field]: value,
      },
    });
  };

  return (
    <div>
      <div className="editor-section">
        <h4 className="editor-section-title">Tracklist Display Options</h4>

        <div className="editor-field" style={{ marginBottom: '1rem' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <input
              type="checkbox"
              checked={block.config.showArtwork !== false}
              onChange={(e) => handleChange('showArtwork', e.target.checked)}
            />
            Show Track Artwork
          </label>
        </div>

        <div className="editor-field" style={{ marginBottom: '1rem' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <input
              type="checkbox"
              checked={block.config.showDuration !== false}
              onChange={(e) => handleChange('showDuration', e.target.checked)}
            />
            Show Track Duration
          </label>
        </div>

        <div className="editor-field" style={{ marginBottom: '1rem' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <input
              type="checkbox"
              checked={block.config.showDownloadLinks !== false}
              onChange={(e) => handleChange('showDownloadLinks', e.target.checked)}
            />
            Show Download Links
          </label>
        </div>

        <div className="editor-field" style={{ marginBottom: '1rem' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <input
              type="checkbox"
              checked={block.config.showTrackNumber || false}
              onChange={(e) => handleChange('showTrackNumber', e.target.checked)}
            />
            Show Track Numbers
          </label>
        </div>

        <div className="editor-field" style={{ marginBottom: '1rem' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <input
              type="checkbox"
              checked={block.config.showArtistName || false}
              onChange={(e) => handleChange('showArtistName', e.target.checked)}
            />
            Show Artist Name
          </label>
        </div>
      </div>

      <div className="editor-section">
        <h4 className="editor-section-title">Styling</h4>

        <div className="editor-field">
          <ColorPicker
            label="Background Color"
            color={block.styles.backgroundColor || 'transparent'}
            onChange={(value) => handleStyleChange('backgroundColor', value)}
          />
        </div>

        <div className="editor-field">
          <label>Padding (px)</label>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.5rem' }}>
            <input
              type="number"
              value={block.styles.padding?.top || 20}
              onChange={(e) => handleStyleChange('padding', { ...block.styles.padding, top: parseInt(e.target.value) })}
              placeholder="Top"
              min="0"
            />
            <input
              type="number"
              value={block.styles.padding?.right || 20}
              onChange={(e) => handleStyleChange('padding', { ...block.styles.padding, right: parseInt(e.target.value) })}
              placeholder="Right"
              min="0"
            />
            <input
              type="number"
              value={block.styles.padding?.bottom || 20}
              onChange={(e) => handleStyleChange('padding', { ...block.styles.padding, bottom: parseInt(e.target.value) })}
              placeholder="Bottom"
              min="0"
            />
            <input
              type="number"
              value={block.styles.padding?.left || 20}
              onChange={(e) => handleStyleChange('padding', { ...block.styles.padding, left: parseInt(e.target.value) })}
              placeholder="Left"
              min="0"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TracklistBlockEditor;
